import { MAXIMUM_CUSTOMER_AGE, MINIMUM_CUSTOMER_AGE } from '@flows/insurance/constants'

const translations = {
  steps: {
    gender: {
      title: {
        de: 'Wähle dein Geschlecht',
        en: 'Select your gender',
      },
      modal: {
        title: {
          de: 'Warum muss ich mein Geschlecht angeben?',
          en: 'Why do I have to specify my gender? ',
        },
        content: {
          de: 'Selbstverständlich hat dein Geschlecht keinerlei Auswirkungen auf deinen Tarif. Mit dieser Angabe hilfst du uns dabei, dich etwas persönlicher anzusprechen.',
          en: 'Of course, your gender has no effect on your rate. With this information you help us to address you more personally.',
        },
      },
    },
    email_and_name: {
      checkboxes: {
        title: {
          de: 'Bitte bestätige die folgenden Dinge:',
          en: 'Please confirm the following:',
        },
        marketingOptIn: {
          de: 'Ich bin damit einverstanden, dass die Getsafe Digital GmbH mir regelmäßig Informationen zu Versicherungsprodukten per E-Mail zuschickt. Meine Einwilligung kann ich jederzeit gegenüber der Getsafe Digital GmbH widerrufen.',
          en: 'I agree that Getsafe Digital GmbH may send me regular information on insurance products by email. I can revoke my consent to Getsafe Digital GmbH at any time.',
        },
        erstinformation: {
          title: {
            de: 'Erstinformationen',
            en: 'Initial information',
          },
          description: {
            de: 'Ich bestätige, dass ich die <a target="_blank" href="https://www.gtsf.insure/documents/erstinformationen.pdf">Erstinformationen</a> heruntergeladen und zur Kenntnis genommen habe.',
            en: 'I confirm that I have take note of and downloaded the <a target="_blank" href="https://www.gtsf.insure/documents/erstinformationen.pdf">initial information (Erstinformationen)</a>.',
          },
        },
        electronic_communication: {
          title: {
            de: 'Electronic Communication',
            en: 'Electronic Communication',
          },
          description: {
            de: 'We would like to keep you informed about our products and special offers, please confirm that you agree that all communication with Getsafe will be done electronically',
            en: 'We would like to keep you informed about our products and special offers, please confirm that you agree that all communication with Getsafe will be done electronically',
          },
          description2: {
            de: 'In order to keep you informed about our products and special offers, please confirm that you agree that all communication with Getsafe will be done electronically.',
            en: 'In order to keep you informed about our products and special offers, please confirm that you agree that all communication with Getsafe will be done electronically.',
          },
        },
      },
      title: {
        en: 'Please provide your personal details:',
        de: 'Bitte gib deine persönlichen Informationen an:',
      },
      infoButton: {
        dataTitle: {
          de: 'Deine Daten',
          en: 'Your data',
        },
        dataExplanation: {
          de: 'Bei uns hat der Schutz deiner Privatsphäre oberste Priorität. Aus diesem Grund behandeln wir deine personenbezogenen Daten mit größter Vorsicht.',
          en: 'Your privacy is important to us. For this reason, we manage your personal information with the greatest care.',
        },
        phoneNumberTitle: {
          de: 'Deine Telefonnummer',
          en: 'Your phone number',
        },
        phoneNumberExplanation: {
          de: 'Wir benötigen deine Telefonnummer, damit wir dich beispielsweise im Schadenfall einfacher erreichen können. So können wir deinen Schaden schneller bearbeiten.',
          en: 'We need your phone number to contact you in the event of a claim, for example. This enables us to process claims more quickly.',
        },
      },
      email: {
        input: {
          label: {
            de: 'E-Mail-Adresse',
            en: 'Email',
          },
        },
      },
      phone: {
        input: {
          label: {
            de: 'Telefonnummer',
            en: 'Phone number',
          },
        },
      },
      firstName: {
        input: {
          label: {
            de: 'Vorname',
            en: 'First name',
          },
        },
      },
      lastName: {
        input: {
          label: {
            de: 'Nachname',
            en: 'Last name',
          },
        },
      },
    },
    damages: {
      title: {
        de: 'Wie viele gemeldete Vorschäden hattest du in den letzten 5 Jahren?',
        en: 'How many claims have you made in the last five years?',
      },
      subtitle: {
        de: 'Es ist wichtig, dass du diese Frage ehrlich beantwortest, da sonst dein Versicherungsschutz im Schadensfall nicht greifen könnte.',
        en: 'It’s important to answer this question honestly, otherwise your insurance cover may not be valid in the case of a claim.',
      },
    },
    zip_code: {
      title: {
        de: 'Bitte gib deine Postleitzahl an.',
        en: 'Please enter your postcode.',
      },
      subtitle: {
        de: 'Um dein Angebot zu erstellen, benötigen wir die Postleitzahl deines Wohnorts.',
        en: 'To customise your plan, we need to know the postcode in which your house or apartment is located.',
      },
      error: {
        notValid: {
          de: 'Bitte gib eine gültige Postleitzahl an.',
          en: 'Please provide a valid postcode.',
        },
        notInsurable: {
          de: 'Leider können wir dir momentan für die angegebene Postleitzahl kein Angebot unterbreiten',
          en: 'Oh no! We don’t cover your area right now.',
        },
      },
    },
    previous_insurance_carrier: {
      fieldName: {
        en: 'Insurer',
        de: 'Versicherer',
      },
    },
    extension: {
      yes: {
        de: 'Ja, ich möchte meinen Schutz erweitern.',
        en: 'Yes, I would like this extra protection',
      },
      no: {
        de: 'Nein, danke.',
        en: 'No, I don’t need the additional coverage',
      },
    },
    location: {
      title: {
        de: 'Wo wohnst du?',
        en: 'Where do you live?',
      },
    },
    deductibles: {
      de: 'Lege deine Selbstbeteiligung fest.',
      en: 'Choose your excess',
    },
    family: {
      modal: {
        text: {
          de: 'Dein Partner/deine Partnerin bzw. deine Familie genießen mit dem Upgrade Familie denselben Versicherungsschutz wie du. Du kannst sie nach Abschluss der Versicherung zu Getsafe einladen, damit sie die Getsafe App herunterladen können und alle Vorteile von Getsafe genießen können.',
          en: 'With Upgrade Family, your partner or family will enjoy the same insurance coverage as you. You can invite them to Getsafe after buying insurance so they can download the Getsafe app and enjoy all the benefits of Getsafe.',
        },
      },
      title: {
        de: 'Für wen suchst du eine Versicherung?',
        en: 'Whom would you like to cover?',
      },
      options: {
        only_myself: {
          de: 'Für mich alleine',
          en: 'Only myself',
        },
        myself_and_family: {
          de: 'Für mich und meine Familie',
          en: 'Myself and my family',
        },
      },
    },
    tariff_line: {
      title: {
        de: 'Bitte wähle deinen Tarif.',
        en: 'Please choose your tariff line.',
      },
      options: {
        premium: {
          de: 'Premium',
          en: 'Premium',
        },
        comfort: {
          de: 'Comfort',
          en: 'Comfort',
        },
      },
      infobox: {
        de: 'Im Premiumtarif genießt du die Bestleistungsgarantie. Das bedeutet für dich: Sollte eine andere Versicherung zum Zeitpunkt des Schadens bessere Leistungen anbieten, so gelten diese automatisch auch für dich bis zur vereinbarten Versicherungssumme.',
        en: 'With premium tariff, you enjoy our best service guarantee. This means that if another insurance company offers better benefits at the time you make a claim, these automatically apply to you as well, up to the agreed insured sum.',
      },
    },
  },
  generic: {
    deductible: {
      title: {
        de: 'Selbstbeteiligung',
        en: 'Excess',
      },
      info: {
        de: 'Die Selbstbeteiligung ist der Betrag, den du im Schadensfall selbst übernimmst. Beispiel: Im Kaufprozess entscheidest du dich für einen Tarif mit 250€ Selbstbeteiligung. Das bedeutet, dass du bei jedem Schaden bis zu 250€ selbst zahlst: Bei einem Schaden von 80€ übernimmst du den kompletten Betrag. Bei einem Schaden von 400€ übernimmst du 250€ und wir die fehlenden 150€.',
        en: 'The excess is the amount you pay yourself in the event of damage. Example: In the buying process you decide on a rate with a € 250 excess. This means that you pay up to € 250 for each damage: If the damage is € 80, you pay the full amount. For a damage of € 400, you pay € 250 and we pay the missing € 150.',
      },
    },
    phoneNumber: {
      de: '+49 6221 3579991',
      en: '+49 6221 3579991',
    },
    placeholder: {
      pleaseSelect: {
        de: '0€',
        en: '0€',
      },
      sumAmountInPounds: {
        de: 'Summe in £',
        en: 'Insured sum in £',
      },
    },
    buttons: {
      showMore: {
        de: 'Mehr anzeigen',
        en: 'Show more',
      },
      showLess: {
        de: 'Weniger anzeigen',
        en: 'Show less',
      },
      showMoreHighlights: {
        de: 'Mehr Highlights anzeigen',
        en: 'Show more highlights',
      },
      showLessHighlights: {
        de: 'Weniger Highlights anzeigen',
        en: 'Show less',
      },
      add_free: {
        de: 'Kostenlos hinzufügen',
        en: 'Add for free',
      },
      added: {
        de: 'Hinzugefügt',
        en: 'Added',
      },
      enter: {
        de: 'Ok',
        en: 'Enter',
      },
    },
    more: {
      information: {
        de: 'Mehr Informationen',
        en: 'More Information',
      },
    },
    learn_more: {
      de: 'Erfahre mehr',
      en: 'Learn More',
    },
    title: {
      please_select: {
        de: 'Bitte wählen:',
        en: 'Please select:',
      },
    },
    inputs: {
      day: {
        de: 'TT',
        en: 'DD',
      },
      month: {
        de: 'MM',
        en: 'MM',
      },
      year: {
        de: 'JJJJ',
        en: 'YYYY',
      },
      yearPlaceholder: {
        de: 'Jahr',
        en: 'Year',
      },
      yes: {
        de: 'Ja',
        en: 'Yes',
      },
      no: {
        de: 'Nein',
        en: 'No',
      },
      true: {
        de: 'Richtig',
        en: 'True',
      },
      false: {
        de: 'Falsch',
        en: 'False',
      },
      male: {
        de: 'Männlich',
        en: 'Male',
      },
      female: {
        de: 'Weiblich',
        en: 'Female',
      },
      diverse: {
        en: 'Diverse',
        de: 'Divers',
      },
      email: {
        de: 'E-Mail-Adresse',
        en: 'Email',
      },
      cc: {
        de: 'Kreditkarte oder Debitkarte',
        en: 'Credit or Debit card',
      },
      cc_name: {
        de: 'Name des Karteninhabers',
        en: 'Cardholder name',
      },
      cc_number: {
        de: 'Kartennummer',
        en: 'Card number',
      },
      cc_ccv: {
        de: 'CVV',
        en: 'CVV',
      },
      cc_date: {
        de: 'Gültig bis',
        en: 'Valid until',
      },
      paypal: {
        de: 'PayPal',
        en: 'PayPal',
      },
      sepa: {
        de: 'Lastschriftmandat erteilen',
        en: 'SEPA Direct Debit Mandate',
      },
      sepa_name: {
        de: 'Name des Kontoinhabers',
        en: 'Account holder',
      },
      sepa_iban: {
        de: 'IBAN',
        en: 'IBAN',
      },
      sepa_mandate: {
        de: 'Ich ermächtige die Getsafe Digital GmbH und deren Zahlungsdienstleister, die Stripe Payments Europe Ltd., Zahlungen von meinem/unserem Konto mittels Lastschrift einzuziehen.',
        en: 'I allow Getsafe Digital GmbH and their payment partner, Stripe Payments Europe Ltd., to take payments from my/our account via direct debit.',
      },
      sepa_mandate_more: {
        de: 'Ich ermächtige die Getsafe Digital GmbH und deren Zahlungsdienstleister, die Stripe Payments Europe Ltd., Zahlungen von meinem/unserem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein/unser Kreditinstitut an, die von der Getsafe Digital GmbH bzw. der Stripe Payments Europe Ltd. auf mein/unser Konto gezogenen Lastschriften einzulösen. Der Lastschrifteinzug wird mir spätestens einen Kalendertag vor dem ersten Einzug angekündigt, womit ich einverstanden bin. Hinweis: Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem/unserem Kreditinstitut vereinbarten Bedingungen. Die Gläubiger-Identifikationsnummer lautet DE13GET00002056329. Als Mandatsreferenznummer verwenden wir deine Versicherungsscheinnummer, die wir dir separat mitteilen.',
        en: 'I allow Getsafe Digital GmbH and their payment partner, Stripe Payments Europe Ltd., to take payments from my/our account via direct debit. I also direct my/our credit institute to honour the direct debits drawn by Getsafe Digital GmbH and Stripe Payments Europe Ltd. from my account. I will be informed of the direct debit payment no later than one day before the first payment I agree to make. Please note: I can demand reimbursement of this direct debit within eight weeks, beginning from the date of payment. The terms and conditions of my/our credit institute apply. The Creditor Identifier is DE13GET00002056329. As mandate reference number, we use your insurance certificate number, which we will inform you of separately.',
      },
      credit_card_mandate: {
        de: 'Ich bin damit einverstanden, dass die Getsafe Digital GmbH und deren Zahlungsdienstleister, die Stripe Payment Europe Ltd., meine Kreditkarte auch für den Einzug zukünftig fälliger Zahlungen aus dem Versicherungsvertrag belastet. Hinweis: Du kannst die Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen und eine andere Zahlart wählen. Kontaktiere uns einfach unter: datenschutz@hellogetsafe.com. ',
        en: 'I agree that Getsafe Digital GmbH and its payment service provider, Stripe Payment Europe Ltd., may also charge my credit card for the collection of future payments due under the insurance contract. Note: You can revoke your consent at any time with effect for the future and choose another payment method. For any changes please contact us at datenschutz@hellogetsafe.com. ',
      },
      list: {
        add: {
          de: 'Mehr hinzufügen',
          en: 'Add More',
        },
        remove: {
          de: 'Entfernen',
          en: 'Remove',
        },
      },
      add: {
        de: 'HINZUFÜGEN',
        en: 'ADD',
      },
      edit: {
        de: 'BEARBEITEN',
        en: 'EDIT',
      },
      update: {
        de: 'ÄNDERUNGEN SPEICHERN',
        en: 'SAVE CHANGES',
      },
      remove: {
        de: 'ENTFERNEN',
        en: 'REMOVE',
      },
      hsn: {
        de: 'HSN',
        en: 'HSN',
      },
      tsn: {
        de: 'TSN',
        en: 'TSN',
      },
    },
    radio_card_set: {
      recommended: {
        de: 'Empfohlen',
        en: 'Recommended',
      },
      most_selected: {
        de: 'Meist gewählt',
        en: 'Most selected',
      },
    },
    legal: {
      agb: {
        de: '',
        en: '',
      },
      erstinformationen: {
        de: '',
        en: '',
      },
    },
    welcome: {
      de: 'Welcome to Getsafe',
      en: 'Welcome to Getsafe',
    },
    text: {
      skip: {
        de: 'Weiter ohne Angabe',
        en: 'Skip',
      },
    },
    extend: {
      coverage: {
        de: 'Schutz erweitern',
        en: 'Extend coverage',
      },
    },
    yourBenefit: {
      de: 'Dein Vorteil',
      en: 'Your benefit',
    },
    dontWeKnowYou: {
      text: {
        de: 'Hey, kennen wir dich nicht?',
        en: 'Hey, don’t we know you?',
      },
      popup: {
        header: {
          de: 'Du bist bereits Getsafe Kunde?',
          en: 'Already a customer?',
        },
        body: {
          de: 'Du scheinst bereits einen Account zu besitzen. Deswegen kannst du die Versicherung jetzt nur noch per App abschließen. Öffne bitte die App, um deine Versicherung abzuschließen.',
          en: 'Do you already have a Getsafe account? To get started with your purchase, please continue in the app. You currently cannot purchase this product with your browser, but we are working on a solution for this.',
        },
        cta: {
          de: 'weiter mit app',
          en: 'switch to app',
        },
      },
    },
    errors: {
      required: {
        de: 'Dieses Feld muss angegeben werden.',
        en: 'This field is required.',
      },
      min_age: {
        en: `You must be at least ${MINIMUM_CUSTOMER_AGE.de} years old to purchase insurance with us.`,
        de: `Du musst mindestens ${MINIMUM_CUSTOMER_AGE.de} Jahre alt sein, um eine Versicherung bei uns abzuschließen.`,
      },
      max_age: {
        de: `Du musst höchstens ${MAXIMUM_CUSTOMER_AGE.de} Jahre alt sein.`,
        en: `You must be at most ${MAXIMUM_CUSTOMER_AGE.de} years old.`,
      },
      email_invalid: {
        de: 'Die eingegebene E-Mail-Adresse ist nicht richtig formatiert.',
        en: 'Invalid email address.',
      },
      phone_invalid: {
        de: 'Bitte gib eine gültige Telefonnummer an',
        en: 'Phone number format is invalid',
      },
      name_invalid_characters: {
        de: 'Enthält unerlaubte Zeichen.',
        en: 'Contains invalid characters.',
      },
      name_incorrect_length: {
        en: 'This field is too long or short',
        de: 'Dieses Feld hat nicht die richtige Länge',
      },
    },
    claims_options: {
      '0': {
        de: 'Keinen Schaden',
        en: 'No claims',
      },
      '0.last': {
        de: 'Keinen Schaden',
        en: 'No claims',
      },
      '1': {
        de: '1 Schaden',
        en: '1 claim',
      },
      '1.last': {
        de: '1 oder mehr Schäden',
        en: '1 or more claims',
      },
      '2': {
        de: '2 Schäden',
        en: '2 claims',
      },
      '2.last': {
        de: '2 oder mehr Schäden',
        en: '2 or more claims',
      },
      '3': {
        de: '3 Schäden',
        en: '3 claims',
      },
      '3.last': {
        de: '3 oder mehr Schäden',
        en: '3 or more claims',
      },
      '4': {
        de: '4 Schäden',
        en: '4 claims',
      },
      '4.last': {
        de: '4 oder mehr Schäden',
        en: '4 or more claims',
      },
    },
  },
  // A quick work around to handle the Input without a label
  // TODO: https://hellogetsafe.atlassian.net/browse/PC-1895
  emptyLine: {
    de: '',
    en: '',
  },
}
export default translations
